/**
 *  @class
 *  @function CollectionTabs
 */
document.addEventListener("DOMContentLoaded", function () {
    // Check if the script has already been executed
    if (sessionStorage.getItem("hideLipsExecuted")) {
        return; // Stop execution if already run
    }

    // Select all matching elements and hide them
    let lipsCollections = document.querySelectorAll('.section-collection-tabs .products.carousel .columns[data-collection="lips"]');
    lipsCollections.forEach(element => {
        element.style.display = "block";
    });

    // Mark that the script has run
    sessionStorage.setItem("hideLipsExecuted", "true");

    // When any .collection-tabs__list-link is clicked, prevent this script from running again
    document.querySelectorAll('.collection-tabs__list-link').forEach(link => {
        link.addEventListener("click", function () {
            sessionStorage.setItem("hideLipsExecuted", "true");
        });
    });
});




if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.init = false; // Voeg een flag toe om initialisatie bij te houden
    }
    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return; // Zorg ervoor dat de section header bestaat
        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });

        // Direct de eerste collectie tonen bij laden
        if (!this.init && buttons.length > 0) {
          buttons[0].click(); // Simuleer een klik op de eerste button
          this.init = true; // Zet de initialisatie flag op true
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return; // Zorg ervoor dat de slider bestaat
      const products = slider.querySelectorAll(`.columns`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);
      const flkty = Flickity.data(slider);

      products.forEach((product) => product.style.display = 'none'); // Verberg alle producten
      activeProducts.forEach((product) => {
        product.classList.add('carousel__slide');
        product.style.display = 'block'; // Toon alleen actieve producten
      });

      flkty.insert(activeProducts);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
